(function () { })();
// jQuery is loaded
if (window.jQuery) {

    (function ($) {

        $(document).ready(function () {
            ////////////////////////////////

            var BS = typeof window.BS !== 'undefined' ? window.BS : (function () {
                alert('BS is not loaded');
            }());

            /* Scroll to error if any */
            BS.scrollToError();

            /* dynamic font size */
            //BS.scaleFont(960, $('#container'));
            /* dynamic font size */

            /* Add all relevant elements to BS.ele */
            (function () {
                BS.addElement('$searchIcon', $('#searchIcon'));
                BS.addElement('$headerNav', $('#headerNav'));
                BS.addElement('$paddles', $('#paddles'));
                BS.addElement('$body', $('body'));
                BS.addElement('$html', $('html'));
                BS.addElement('$logo', $('#logo'));
                BS.addElement('$menu', $('#open-nav'));
                BS.addElement('$window', $(window));
                BS.addElement('$productImage', $('div.product-image'));
                BS.addElement('$imgContainer', $('#mainImage'));
                BS.addElement('$zoomplace', $('#zoomplace'));
                BS.addElement('$footerNav', $('div.footer-nav'));
            }());

            /* add body class depending on devices desktop or mobile*/
            (function () {
                var deviceDetection = typeof window.deviceDetection !== 'undefined' ? window.deviceDetection : (function () {
                    BS.log('deviceDetection script is not loaded');
                });

                if (deviceDetection.isSmartphoneOrTablet) {
                    BS.ele.$body.addClass('mobile');
                } else {
                    BS.ele.$body.addClass('desktop');
                }
            }());

            /* mobile menu */
            (function () {
                //$('#wrapper').prepend('<div class="cover"></div>');
                BS.ele.$menu.on(
                    'click',
                    function () {
                        //$(this).find('span').toggleClass('is-opened');
                        BS.ele.$body.toggleClass('navopen');
                        if (BS.ele.$headerNav.hasClass('searchshow')) {
                            BS.ele.$headerNav.removeClass('searchshow');
                            BS.ele.$logo.removeClass('logofade');
                        }
                        /* paddle arrow force kick off */
                        BS.ele.$window.trigger('resize');
                    }
                );
            }());
            /* mobile menu ends */

            /* search not use */
            (function () {

                BS.ele.$searchIcon.on('click',
                    function (event) {
                        event.preventDefault();

                        BS.ele.$headerNav.toggleClass('searchshow');

                        if (BS.ele.$headerNav.hasClass('searchshow')) {
                            BS.ele.$headerNav.removeClass('searchhide');

                            if (BS.ele.$body.hasClass('small-view')) {
                                BS.ele.$logo.addClass('logofade');
                            }

                        } else {
                            BS.ele.$headerNav.addClass('searchhide');

                            if (BS.ele.$body.hasClass('small-view')) {
                                BS.ele.$logo.removeClass('logofade');
                            }
                        }
                    }
                );
            });

            /* navigation */
            (function () {
                /* normal desktop navigations */
                if ($("#headerNav").length) {
                    $("#headerNav ul").carousel({
                        itemsSelector: '#header .mod_customnav'
                    });
                }

                if ($("#imageNav").length) {
                    $('#imageNav').carousel({
                        itemsSelector: ".content-level2-navigation"
                    });
                }
            }());

            //Related product
            if ($("div.carousel-rel-product").length) {
                $("div.carousel-rel-product").carousel({
                    itemsSelector: ".carousel-rel-product"
                });
            }

            /* Spot-light teaser images NotUsed */
            (function () {
                var $spotLights = $('div.spot-light .ce_image');
                BS.rollNumber($spotLights);
                BS.ele.$window.on('resize', BS.debounce(
                    function () {
                        var sl_width = $spotLights.first().width(),
                            sl_height = Math.floor(sl_width / 1.65);
                        $spotLights.each(function (index) {
                            $(this).css('height', sl_height);
                        });
                    },
                    120
                )).trigger('resize');
            });

            /* Footer blocks */
            (function () {
                // BS.nthOfClassMark($('div.logo .ce_image'), 'n+3');
                BS.rollNumber($('#footer .one-sixth'));
            }());


            /* Fixed header form Validation error position fix */
            (function () {
                var $submit = $('.submit'),
                    correctionSpace = 60,
                    parentDivClass = '.widget';

                $submit.on('click', function () {
                    setTimeout(function () {
                        var $focused = $(':focus');
                        var $focusedWrap = $focused.closest(parentDivClass).addClass('focusedError');

                        $("html, body").animate({
                            scrollTop: ($focusedWrap.offset().top - correctionSpace)
                        }, 500);

                        $focused.keydown(function () {
                            $focusedWrap.removeClass('focusedError');
                        });
                    }, 1);
                });
            }());


            /* breakpoint-change */
            (function () {
                /* must be called to register event */
                BS.MediaQueryObserve();

                BS.ele.$window.on('breakpoint-change', function (e, objMQ) {
                    if (!BS.ele.$body.hasClass(objMQ.currentBreakpoint)) {
                        BS.ele.$body.removeClass(objMQ.lastBreakpoint);
                        BS.ele.$body.addClass(objMQ.currentBreakpoint);
                    }

                    //add which view and header update if needed
                    if (BS.ele.$body.hasAnyClass('w320px w479px w480px')) {
                        BS.ele.$body.addClass('small-view');

                        //Do header update
                        if (BS.ele.$headerNav.hasClass('searchshow')) {
                            BS.ele.$logo.addClass('logofade');
                        }

                    } else {
                        BS.ele.$body.removeClass('small-view navopen');

                        //Do header update
                        if (BS.ele.$headerNav.hasClass('searchshow')) {
                            BS.ele.$logo.removeClass('logofade');
                        }
                    }
                });
            }());


            /* language changer selection footer */
            (function () {
                var $navlang = $("#footer nav.mod_changelanguage").addClass('select'),
                    $select,
                    $baseURL = $('base').attr('href');

                // Create the dropdown base
                $select = $("<select />").appendTo($navlang);
                $select.wrap($('<div class="field_div"/>'));

                // Create default option "Go to..."
                $("<option />", {
                    "selected": "selected",
                    "value": "",
                    "text": $navlang.find('h2').text()
                }).appendTo($select);

                // Populate dropdown with menu items
                $navlang.find("a").each(function () {
                    var el = $(this);
                    $("<option />", {
                        "value": el.attr("href"),
                        "text": el.text()
                    }).appendTo($select);
                });


                $navlang.find('ul').hide();

                $select.change(function () {
                    if (window.location.href === $(this).find("option:selected").val()) {
                        return;
                    }

                    window.location = $(this).find("option:selected").val();
                });
            });

            /* language changer selection footer */
            (function () {
                var $navlang = $("#footer nav.mod_changelanguage").addClass('select'),
                    $select,
                    $baseURL = $('base').attr('href');

                // Create the dropdown base
                $select = $("<select />").appendTo($navlang);
                $select.wrap($('<div class="field_div"/>'));

                // Create default option "Go to..."
                $("<option />", {
                    "selected": "selected",
                    "value": "",
                    "text": $navlang.find('strong').text() || 'default'
                }).appendTo($select);

                // Populate dropdown with menu items
                $navlang.find("a").each(function () {
                    var el = $(this);
                    $("<option />", {
                        "value": el.attr("href"),
                        "text": el.text()
                    }).appendTo($select);
                });


                $navlang.find('ul').hide();
                $navlang.find('#activelangauge').hide();

                $select.change(function () {
                    if (window.location.href === $(this).find("option:selected").val()) {
                        return;
                    }

                    window.location = $(this).find("option:selected").val();
                });
            }());

            /* language changer header top */
            (function () {
                var $navlangtop = $("#headerTop nav.mod_changelanguage");

                $navlangtop.find('button').click(
                    function () {
                        $navlangtop.toggleClass('open');
                    }
                );

                //Close drop down if click else where
                $('body').on('click', function (event) {
                    if (!$(event.target).is('.mod_changelanguage') &&
                        !$(event.target).parents('.mod_changelanguage').length) {
                        $navlangtop.removeClass('open');
                    }
                });

            });

            /* language changer header */
            (function () {
                var $navlangtop = $("#header nav.mod_changelanguage");

                $navlangtop.wrap('<div class="langchangewrap block"/>');
                $navlangtop.find('button').click(
                    function () {
                        $navlangtop.toggleClass('open');
                    }
                );

                //Close drop down if click else where
                $('body').on('click', function (event) {
                    if (!$(event.target).is('.mod_changelanguage') &&
                        !$(event.target).parents('.mod_changelanguage').length) {
                        $navlangtop.removeClass('open');
                    }
                });

            }());


            /* tabbed menu */
            (function () {
                /*
                 $tabbedmenu = $('.tabscontent');
                 if($tabbedmenu.length) {
                 $tabbedmenu.tabbedContent();
                 }
                 */
                $('div.tabsmenu li').click(function () {
                    var tab_id = $(this).attr('data-tab');

                    $('div.tabsmenu li').removeClass('current');
                    $('.tab-content').removeClass('current');

                    $(this).addClass('current');
                    $("#" + tab_id).addClass('current');
                });

            }());

            /* table zoom */
            (function () {
                var $firstTable = $('div.tabelle2 table').first();

                $firstTable.click(function () {
                    $(this).colorbox({
                        html: '<table>' + $(this).html() + '</table>',
                        height: BS.ele.$window.innerHeight(),
                        width: BS.ele.$window.innerWidth(),
                        onComplete: function () {
                            BS.ele.$window.on('resize.tabelle2 orientationchange.tabelle2', function () {
                                $.colorbox.resize({
                                    height: BS.ele.$window.innerHeight(),
                                    width: BS.ele.$window.innerWidth()
                                });
                            });
                        },
                        onClosed: function () {
                            BS.ele.$window.off('.tabelle2');
                        }
                    });
                });
            }());


            /* Fixed header Position */
            (function () {
                var $header = $('#header'),
                    hHeight = $header.outerHeight(),
                    $headerSpace;

                $header.css({
                    "position": "fixed",
                    "top": 0,
                    "left": 0,
                    "right": 0,
                    "z-index": 666
                });

                $headerSpace = $('<div/>', {
                    "css": {
                        "height": hHeight
                    }
                });
                $header.after($headerSpace);
            });
            /* Fixed header Position ends */

            /* Fixed header Position 2 */
            (function () {
                var $header = $('#header'),
                    hHeight = $header.outerHeight(),
                    $headerTop = $('#headerTop'),
                    headerTopHeight = 0,
                    $headerSpace;

                $headerSpace = $('<div/>', {
                    'class': 'headerSpace',
                    'css': {
                        'height': hHeight,
                        'position': 'fixed',
                        'top': 0,
                        'left': 0,
                        'right': 0
                    }
                });
                $header.after($headerSpace);

                if ($headerTop.length) {
                    headerTopHeight = $headerTop.outerHeight();
                } else {
                    $header.css({
                        'position': 'fixed',
                        'top': 0,
                        'left': 0,
                        'right': 0,
                    });
                    $headerSpace.css('position', 'relative');
                }

                setHeaderXFix = function () {
                    if (BS.scrollTop > headerTopHeight) {
                        $('body').addClass('fixedHeader');
                    } else {
                        $('body').removeClass('fixedHeader');
                    }

                    window.requestAnimationFrame(setHeaderXFix);
                };

                window.requestAnimationFrame(setHeaderXFix);

            }());
            /* Fixed header Position 2 ends */



            /* elevatezoom */
            (function () {
                var $img = BS.ele.$imgContainer.find('img'),
                    w,
                    h,
                    makeDivSameHeight,
                    $imgPlace;

                /* make same height */
                makeDivSameHeight = function () {
                    var $height;
                    if (deviceDetection.isSmartphone) {
                        BS.ele.$zoomplace.css('height', 'auto');
                        BS.ele.$imgContainer.parent().css('height', 'auto');

                        return;
                    } else {
                        $height = Math.max(BS.ele.$zoomplace.outerHeight(), BS.ele.$imgContainer.parent().outerHeight());
                        BS.ele.$zoomplace.css('height', $height);
                        BS.ele.$imgContainer.parent().css('height', $height);
                    }
                };

                makeDivSameHeight();

                /* dont do any thing on mobile */
                if (deviceDetection.isSmartphone) {
                    return;
                } else {
                    if ($img.length) {
                        w = Math.min($img[0].naturalWidth, BS.ele.$zoomplace.outerWidth());
                        h = Math.min($img[0].naturalHeight, BS.ele.$zoomplace.outerHeight());

                        if ($img.data('zoom-image')) {

                            BS.ele.$zoomplace.prepend('<div id="imageplace"></div>');
                            $imgPlace = $('#imageplace');

                            /**/
                            $imgPlace.prepend($('<img>', {
                                id: 'theImg',
                                src: $img.data('zoom-image')
                            }));

                            $imgPlace.css({
                                height: h - 1,
                                'line-height': h - 1 + 'px'
                            });

                            $img.on('click', function () {
                                $imgPlace.toggle();
                            }).css({ 'cursor': 'pointer' });


                            /*
                             $img.elevateZoom({
                             zoomEnabled: true,
                             zoomWindowPosition: 1,
                             borderSize : 1,
                             zoomWindowWidth : w,
                             zoomWindowHeight : h,
                             zoomWindowPosition: "zoomplace",
                             scrollZoom : false
                             });
                             */
                        }
                    }
                }

                /* remove style if*/
                BS.ele.$window.on('resize orientationchange', function () {
                    BS.debounce(makeDivSameHeight, 200);
                });


            }());

            /* Filter & Weiter info blocks */
            (function () {
                var $weiterArticle = $('div.more-info, div.fw-filter'),
                    $handle = $('<div/>', {
                        "class": 'handle',
                        "text": BS.lang.wi[BS.page_lang]
                    });

                $.each($weiterArticle, function (i, val) {
                    $handle = $handle.clone().on('click', function () {
                        $handle = $(this);
                        /* filter */
                        if ($handle.hasClass('fil')) {
                            $(val).toggle('slow', function () {
                                //complete
                                if ($handle.hasClass('complete')) {
                                    $.cookie('vrfilter', 0);
                                } else {
                                    $.cookie('vrfilter', 1);
                                }
                                $handle.toggleClass('complete');

                            });
                        } else {
                            $(val).toggle(0, function () {
                                //complete
                                $handle.toggleClass('complete');
                            });
                        }
                    });

                    //custom for filter only
                    if ($(val).hasClass('fw-filter')) {
                        $handle.addClass('fil');
                        $handle.text(BS.lang.filter[BS.page_lang]);

                        //if its opened, then keep it open
                        if ($.cookie('vrfilter') == 1) {
                            $handle.addClass('complete');
                            $(val).css('display', 'block');
                        }
                    }

                    $(val).before($handle);

                });
            }());

            /*  Weiter info blocks */
            (function () {
                var $weiterInfo = $('div.fw-notice, div.fw-apply, div.fw-enroll'),
                    $handle = $('<div/>', {
                        "class": 'handle',
                        "text": BS.lang.wi[BS.page_lang]
                    });

                $weiterInfo.each(function (i, val) {
                    $(val).wrap('<div class="fw-notice-wrap" style="position:relative"></div>');

                    //set correct text
                    if ($(val).hasClass('fw-apply')) {
                        $handle.text(BS.lang.apply[BS.page_lang]);
                    }

                    if ($(val).hasClass('fw-enroll')) {
                        $handle.text(BS.lang.enroll[BS.page_lang]);
                    }

                    $handle = $handle.clone().on('click', function () {
                        $(val).toggle();

                        //show the form
                        if (!$handle.hasClass('complete')) {
                            $("html, body").animate({
                                scrollTop: Math.max(BS.ele.$window.scrollTop(), ($handle.offset().top - BS.ele.$window.scrollTop()))
                            }, 400);
                        }

                        $handle.toggleClass('complete');
                    });

                    $(val).before($handle);

                    /* keep open if there is an error inside notice, and scroll to it */
                    if ($(val).find('p.error').length) {
                        $(val).toggle();
                        $handle.toggleClass('complete');
                        BS.scrollToError();
                    }
                });

            }());


            /* Select submit with class changesubmit */
            (function () {
                $(window).on("upDateEvent", function () {
                    var $select = $('div.changesubmit select'),
                        $baseURL = $('base').attr('href');
                    $select.on('change', function () {
                        if (window.location.pathname.endsWith($(this).find("option:selected").val())) {
                            return;
                        }

                        if ($('#cboxOverlay').length) {
                            $('#cboxOverlay').append($('<div>', {
                                "class": 'loading'
                            })).css('display', 'block');
                        }
                        //replace(/<!--(.*?)-->/gm, "")); removes comment from debug mode
                        window.location = $baseURL + $(this).find("option:selected").val().replace(/<!--(.*?)-->/gm, "");
                    });
                });

            }());

            /* Select menu styling */
            /* enable chosen */
            (function () {
                /* remove outer border*/
                $(".select div.field_div").css('border', 'none');
                $("select").chosen({ disable_search: true });
            }); //dont' call
            /* or select fix */
            (function () {
                $(window).on("upDateEvent", function () {
                    var $select = $("select");
                    $select.each(
                        function () {
                            var $this = $(this);
                            $this.$span = $('<span/>', {
                                "class": 'selected',
                                "text": $this.find("option:selected").text()
                            });
                            $this.before($this.$span);
                            $this.on('change focus', function () {
                                $this.$span.text($this.find("option:selected").text());
                            });
                        }
                    );
                });
                $(window).trigger("upDateEvent");
            }());
            /* Select menu styling ends */




            /* Footer Accordion */
            (function () {

                BS.ele.$window.on('breakpoint-change', function (e, objMQ) {
                    if (BS.ele.$body.hasClass('w479px')) {
                        /* Footer Accordion */
                        BS.ele.$footerNav.accordion({
                            heightStyle: 'content',
                            header: 'h2',
                            collapsible: true,
                            active: 'none'
                        });
                    } else {
                        if (BS.ele.$footerNav.accordion("instance") !== undefined) {
                            BS.ele.$footerNav.accordion('destroy');
                        }
                    }
                });
            }());


            /* masonry */
            (function () {
                BS.ele.$window.on('breakpoint-change', function (e, objMQ) {
                    if (!BS.ele.$body.hasClass('w479px')) {
                        /* Add masonry */
                        $('.masonry').masonry({
                            // options
                            itemSelector: '.grid-item',
                            isFitWidth: true
                        });
                    } else {
                        $('.masonry').masonry('destroy');
                    }
                });
            }());


            /* Form show/hide field, with trigger
             *  used in IDW world 'use it now form'.
             * */
            (function () {
                $form = $('#main div.ce_form > form');
                $form.each(
                    function (ele) {
                        $form = $(this);
                        $handel = $form.find('.widget-checkbox.show-billAddressField');
                        $target = $form.find('.widget.billAddressField');
                        $target.hide();

                        if ($handel.length) {
                            $checkbox = $handel.find('input.checkbox');
                            if ($checkbox.prop("checked")) {
                                $target.show();
                            }
                            $handel.on('click', function () {
                                if ($checkbox.prop("checked")) {
                                    $target.show();
                                    $target.find('textarea').prop('required', true);
                                } else {
                                    $target.hide();
                                    $target.find('textarea').prop('required', false);
                                }
                            });
                        }
                    }
                );
            }());


            /* nthOfClass Marker */
            (function () {
                $('div.content-text .sqrBlock').last().addClass('sqrLast');
                BS.rollNumber($('ul .one-fifth'));
            }());

            /* Form Submit loader */
            (function () {
                $form = $('form.submit-loader');
                var $loader = $('<div class="loader"></div>');
                $form.on('submit', function () {
                    $(this).
                        append($loader).
                        find('.widget-submit').remove();
                });
            }());

            /* input,select not zoom on ios */
            (function () {
                $("input[type=text], input[type=email], input[type=password], textarea, select").on({
                    'touchstart': function () {
                        zoomDisable();
                    }
                });

                $("input[type=text], input[type=email], input[type=password], textarea, select").on({
                    'touchend': function () {
                        setTimeout(zoomEnable, 500);
                    }
                });

                function zoomDisable() {
                    $('head meta[name=viewport]').remove();
                    $('head').prepend('<meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=0" />');
                }
                function zoomEnable() {
                    $('head meta[name=viewport]').remove();
                    $('head').prepend('<meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=1" />');
                }
            }());

            /* tooltips */
            (function () {
                var $toolTip = $('.askprice');
                if ($toolTip.length) {
                    $toolTip.tooltip({
                        position: { my: "left-100 top-35", at: "right center" }
                    });
                    $(window).on('resize orientationchange', function () {
                        $toolTip.tooltip("close");
                    });
                }
            }());


            /* isotope product list */
            // This is now called in mixy
            var isoBlock = function () {
                var $eyeCatchers = $('div.product_list .iso_block'),
                    maxHeight = 0,
                    $baseURL = $('base').attr('href'),
                    resizeEyeCatcher = function () {
                        $eyeCatchers.css('height', '');
                        $eyeCatchers.each(function (index) {
                            var h;
                            if ((h = $(this).outerHeight()) > maxHeight) {
                                maxHeight = h;
                            }
                        }).promise().done(function () {
                            $eyeCatchers.css('height', maxHeight);
                            maxHeight = 0;
                        });
                    },
                    setLinkOnDiv = function ($ecEle) {
                        var link = $ecEle.find('a').attr('href');
                        if (link !== undefined) {
                            $ecEle.css({
                                'cursor': 'pointer'
                            });
                            $ecEle.on('click', function () {
                                window.location.href = $baseURL + link;
                            });

                            $ecEle.find('div.details').hide();

                            // set effects
                            $ecEle.hover(
                                function () {
                                    $(this).addClass('hoverIn');
                                },
                                function () {
                                    $(this).removeClass('hoverIn');
                                }
                            );

                        }//end if
                    };

                resizeEyeCatcher();

                $eyeCatchers.each(function (index) {
                    // set the link
                    setLinkOnDiv($(this));
                });

                BS.ele.$window.resize(
                    BS.debounce(resizeEyeCatcher, 250)
                );
                // Set link on the Div
            };
            isoBlock();

            /* Mixy Filter*/
            (function () {
                var buttonFilter = {
                    // Declare any variables we will need as properties of the object
                    $filters: null,
                    $reset: null,
                    $showall: null,
                    groups: [],
                    outputArray: [],
                    outputString: '',
                    $mix: null,

                    // The "init" method will run on document ready and cache any jQuery objects we will need.
                    init: function () {
                        var self = this; // As a best practice, in each method we will asign "this" to the variable "self" so that it remains scope-agnostic. We will use it to refer to the parent "buttonFilter" object so that we can share methods and properties between all parts of the object.

                        self.$filters = $('div.mod_iso_cumulativefilter');
                        self.$reset = $('#Reset');
                        self.$showall = $('#Showall');
                        self.$container = $('#mixitContainer');
                        self.$mix = $('.mix');

                        self.$filters.first().find('ul ul').each(function () {
                            self.groups.push({
                                $buttons: $(this).find('.filter-btn'),
                                active: ''
                            });
                        });



                        for (var i = 0, group; group = self.groups[i]; i++) {
                            group.$buttons.each(function (index, ele) {
                                //Add count span
                                $(ele).find('span.cfil').append(' <span class="result_count"></span>');
                            });
                        }

                        self.updateCount();
                        self.bindHandlers();
                    },

                    // The "bindHandlers" method will listen for whenever a button is clicked.

                    bindHandlers: function () {
                        var self = this;

                        // Handle filter clicks
                        self.$filters.on('click', '.filter-btn', function (e) {
                            e.preventDefault();

                            var $button = $(this);

                            if ($button.find('span.result_count').text() == '(0)') {
                                return;
                            }

                            // Toggle active class
                            $button.hasClass('active') ?
                                $button.removeClass('active') :
                                $button.addClass('active');

                            self.parseFilters();
                        });

                        // Handle reset click
                        self.$reset.on('click', function (e) {
                            e.preventDefault();

                            self.$filters.find('.filter-btn').removeClass('active');

                            self.$container.mixItUp('setOptions', {
                                pagination: {
                                    limit: 12
                                }
                            });

                            self.parseFilters();
                        });

                        self.$showall.on('click', function (e) {
                            var $this = self.$showall;
                            e.preventDefault();

                            if ($this.hasClass('active')) {
                                $this.removeClass('active');
                                self.$container.mixItUp('setOptions', {
                                    pagination: {
                                        limit: 12,
                                        maxPagers: false
                                    }
                                });
                                self.parseFilters();
                            } else {
                                $this.addClass('active');
                                self.$container.mixItUp('paginate', {
                                    page: 1,
                                    limit: 0
                                });
                            }
                        });
                    },

                    // The parseFilters method checks which filters are active in each group:

                    parseFilters: function () {
                        var self = this;

                        // loop through each filter group and grap the active filter from each one.
                        for (var i = 0, group; group = self.groups[i]; i++) {
                            $actived = group.$buttons.filter('.active');
                            group.active = '';
                            $actived.each(function (index, ele) {
                                group.active += $(ele).attr('data-filter') || '';
                            });
                        }

                        self.concatenate();
                    },

                    // The "concatenate" method will crawl through each group, concatenating filters as desired:

                    concatenate: function () {
                        var self = this;

                        self.outputString = ''; // Reset output string

                        for (var i = 0, group; group = self.groups[i]; i++) {
                            self.outputString += group.active;
                        }

                        !self.outputString.length && (self.outputString = 'all');

                        self.updateCount();
                        //console.log(self.outputString);

                        // Send the output string to MixItUp via the 'filter' method:
                        if (self.$container.mixItUp('isLoaded')) {
                            self.$container.mixItUp('filter', self.outputString);
                        }
                    },

                    updateCount: function () {

                        var self = this;
                        var currentString = '';
                        var $newSet = self.$mix; //Initially set to all items


                        //Reduced the set to previously selected items
                        if (self.outputString.length && self.outputString !== 'all') {
                            $newSet = self.$mix.filter(self.outputString);
                            currentString = self.outputString;
                        }

                        //Find the count of all items to a filter button
                        for (var i = 0, group; group = self.groups[i]; i++) {
                            group.$buttons.each(function (index, ele) {
                                var $ele = $(ele);
                                var $effectiveEle = $newSet.filter($ele.attr('data-filter') + currentString);
                                $ele.find('span.result_count').text('(' + $effectiveEle.length + ')');
                            })
                        }
                    }

                };

                buttonFilter.init();

                //return if there is no mixy function
                if (typeof buttonFilter.$container.mixItUp != 'function') {
                    return;
                }

                buttonFilter.$container.mixItUp({
                    controls: {
                        enable: true // we won't be needing these
                    },
                    callbacks: {
                        onMixFail: function (state) {
                            alert('No elements found matching');
                        },
                        onMixEnd: function (state) {
                            var Limit = state.limit + 1;

                            isoBlock();


                            //show reset button only if some filter is set
                            if ($('a.filter-btn.active').length) {
                                buttonFilter.$reset.css('display', 'block');
                            } else {
                                buttonFilter.$reset.css('display', 'none');
                            }

                            //do not show, show all button if there are less products than limit
                            if (buttonFilter.$mix.length < Limit) {
                                buttonFilter.$showall.hide();
                            } else if (buttonFilter.outputString.length > 3 && $(buttonFilter.outputString).length < Limit) {
                                buttonFilter.$showall.hide();
                            }
                            else {
                                buttonFilter.$showall.show();
                            }

                        }
                    },
                    animation: {
                        enable: false
                    },
                    selectors: {
                        target: 'div.mix',
                        filter: 'none'
                    },
                    pagination: {
                        limit: 12,
                        maxPagers: false
                    }
                });
            }());
            //

            /* open external link in new window */
            (function () {
                var $extLinks = $('a.externallink, .externallink');
                $extLinks.each(function (index) {
                    $(this).attr('target', '_blank');
                    $(this).first('a').attr('target', '_blank');
                });
            }());
            /* open external link end */



            /* open popup overlay duktus/keula */
            (function () {
                var $urldom = url('?dom');
                var showOverlay = function ($ele, $closeBtn) {
                    $ele.popup({
                        autoopen: true,
                        transition: 'all 0.3s',
                        background: false,
                        horizontal: 'center',
                        vertical: 'top',
                        blur: false,
                        beforeopen: function () {
                            $ele.css('margin-top', $('#header').outerHeight());
                        },
                        onopen: function () { $duktusNote.css('display', 'inline-block'); },
                        closeelement: $closeBtn
                    });
                };


                if ($urldom == 'duktus') {
                    $duktusNote = $('.duktus-notice');
                    $closeBtn = $('<div class="closeBtn"></div>');
                    $duktusNote.prepend($closeBtn);
                    showOverlay($duktusNote, $closeBtn);
                }


                if ($urldom == 'keula') {
                    $keulaNote = $('.keula-notice');
                    $closeBtn = $('<div class="closeBtn"></div>');
                    $keulaNote.prepend($closeBtn);
                    showOverlay($keulaNote, $closeBtn);
                }

            }());
            /* open popup overlay duktus/keula ends */





            /* Debug screen width */
            (function () {
                var $infobox = $('<div id="js-infobox"></div>');
                $infobox.css({
                    'position': 'fixed',
                    'z-index': 100,
                    top: 0,
                    left: 0
                });
                var upDateInfo = function () {
                    $infobox.text(BS.windowWidth);
                };

                if ($.url('?debug') !== undefined) {
                    BS.ele.$body.prepend($infobox);
                    $(window).on('load resize', BS.debounce(
                        upDateInfo,
                        10
                    ));
                }
            }());
            /* Debug screen width ends */


            /* Build Main Navigation */
            (function () {
                var $mainNavi = $('#mainNavi'),
                    api,
                    activateMmenu = function () {

                        if (!$mainNavi.length) {
                            return;
                        }

                        $.mmenu.configuration.classNames.selected = 'active';

                        $mainNavi.mmenu(
                            {
                                extensions: [
                                    "border-full"
                                ],
                                drag: {
                                    open: false,
                                    maxStartPos: 50,
                                    pageNode: BS.ele.$wrapper,
                                    threshold: 50
                                },
                                offCanvas: {
                                    position: "right", //add position.css
                                    pageSelector: BS.ele.$wrapper,
                                    zposition: "front"
                                },
                                "slidingSubmenus": false,
                                navbar: {
                                    title: ''
                                }
                            },
                            {
                                clone: true
                            }
                        );
                        BS.menuapi = api = $("#mm-mainNavi").data("mmenu");

                        //used in bsmmenu.js, to open on swipe
                        BS.menuapi.openOnSwipe = false;

                        //Extra function
                        //linkolink(api);
                        deactiveNonClickLink(api);
                        insertContent();
                    },

                    insertContent = function () {
                        //var $trigger2 = $('<div class="nav-icon-wrap_"><div class="nav-icon_"><span class="s1"></span><span class="s2"></span><span class="s2"></span><span class="s3"></span></div></div>');
                        var $trigger2 = $('<div class="close">x</div>');

                        var $menuNav = BS.menuapi.getInstance().$menu.find('.mm-panel > ul.level_1.mm-listview');

                        var $logo = $('#header #logo').clone();
                        var $languageChange = $('#header nav.mod_changelanguage').clone();
                        var $search = $('#header .search-form').clone();

                        $menuNav.before($logo)
                            .after($trigger2)
                            .after($languageChange)
                            .after($search);


                        $trigger2.click(function () {
                            BS.menuapi.close();
                        });

                    },

                    deactiveNonClickLink = function (api) {
                        var $nolink = $('.mm-panel a.no-link');
                        $nolink.each(function (ind, ele) {
                            var $linkEle = $(ele);
                            $linkEle.on('click', function (event) {
                                event.stopPropagation();
                                event.preventDefault();
                                $linkEle.siblings('a.mm-next').trigger('click');
                            });
                        });
                    },


                    buildNavigation = function () {

                        var $activeUL;
                        // var $trigger = $('<div class="nav-icon-wrap"><div class="nav-icon"><span class="s1"></span><span class="s2"></span><span class="s2"></span><span class="s3"></span></div></div>');
                        // // $('body').prepend(trigger);

                        activateMmenu();

                        // $trigger.on('click', function () {
                        //     if (BS.ele.$html.hasClass('mm-opened')) {
                        //         api.close();
                        //     } else {
                        //         api.open();
                        //     }
                        // });

                        // $('#header').append($trigger);

                        //clone with event listener
                        // var triggerCopy = $trigger.clone(true, true);

                        $('#header .navi a').on('click', function (event) {
                            event.preventDefault();
                            BS.menuapi.open();
                        });
                    };

                //Initially build both navigation
                buildNavigation();

            }());
            /* mobile menu ends */


            /* Inject flex boxes */
            (function () {
                var $flexBoxContainer = $("[class*='flex-col'].ce_multicolumnStart .col-inside");
                var $flexBox = $('<div/>', {
                    'class': 'block flexPad'
                });
                var addFlexBox = function ($ele, count) {
                    for (var i = 0; i < count; ++i) {
                        $ele.append($flexBox.clone().addClass('box' + i));
                    }
                }

                $flexBoxContainer.each(function (i, val) {

                    if ($(val).parent().hasClass('flex-col3')) {
                        addFlexBox($(val), 2);
                    }

                    if ($(val).parent().hasClass('flex-col4')) {
                        addFlexBox($(val), 3);
                    }

                    if ($(val).parent().hasClass('flex-col5')) {
                        addFlexBox($(val), 4);
                    }

                    if ($(val).parent().hasClass('flex-col6')) {
                        addFlexBox($(val), 5);
                    }
                });

            }());
            /* Inject flex boxes ends */

            /* header search toggle */
            (function () {

                $curtain = $('<div class="curtain">');
                $("#wrapper").append($curtain);
                $("#header").append($curtain);
                $('#header .search a').on('click', function (event) {
                    event.preventDefault();
                    BS.ele.$html.toggleClass("showsearch");
                    $('#header').toggleClass("showsearch");
                    $('#header .search-form ').find('input.text').focus();
                });

                $curtain.on('click', function () {
                    BS.ele.$html.removeClass("showsearch");
                    $('#header').removeClass("showsearch");
                })
            });


            /* typeahead function */
            (function () {

                var lang = BS.page_lang || $('html').attr('lang');
                var searchWord = '';

                // Set the Options for "Bloodhound" suggestion engine
                var engine = new Bloodhound({
                    remote: {
                        url: '/contao-search?lang=' + lang + '&q=%QUERY%',
                        wildcard: '%QUERY%'
                    },
                    queryTokenizer: Bloodhound.tokenizers.whitespace,
                    datumTokenizer: Bloodhound.tokenizers.whitespace
                });

                var findFullString = function (search, haysack) {

                    var normalizedHaysack = haysack.toLowerCase();
                    var normalizedSearch = search.toLowerCase().trim();
                    var haysackParts = normalizedHaysack.split(normalizedSearch);
                    var fullString = '';

                    if (haysackParts.length > 1) {
                        var lastSpaceInParts1 = Math.max(haysackParts[0].lastIndexOf(' '), 0);
                        var firstSpaceInParts2 = Math.max(haysackParts[1].indexOf(' '), 0);

                        var Pos1 = lastSpaceInParts1;
                        var Pos2 = haysackParts[0].length + normalizedSearch.length + firstSpaceInParts2;

                        fullString = haysack.substring(Pos1, Pos2).trim();
                    }

                    return fullString;
                }


                $('.typeahead input').typeahead(
                    {
                        hint: true,
                        highlight: true,
                        minLength: 1
                    },
                    {
                        name: 'bstypeahead',

                        //This is the text populated in search field
                        display: 'title',

                        // display: function (obj) {
                        //     // console.log(obj);
                        //     //return obj.title + ' ' + searchWord;
                        //     return sessionStorage.getItem('search-txt');
                        // },

                        source: engine,

                        templates: {
                            suggestion: function (data) {
                                // console.log(data.text);
                                var searchWord = data._query;
                                var fullString = findFullString(searchWord, data.text) || '';

                                sessionStorage.setItem('search-txt', searchWord);

                                return '<div><a href="' + data.url + '">' + data.title + ' (' + fullString + ')</a></div>';
                            }
                        }
                    }
                );

                $('.typeahead input').bind('typeahead:select', function (ev, suggestion) {
                    // console.log(suggestion.url);
                    location.href = suggestion.url;
                });

            });


        });
        // ONREADY END

        // ONLOAD
        $(window).on('load', function () {

        });
        // ONLOAD END
        ////////////////////////////////
    })(jQuery);



}
// Mootool loaded
else if (window.MooTools) {
    (function ($) {
        window.addEvent('domready', function () {
            ////////////////////////////////
            ////////////////////////////////
        });
    })(document.id);
}



















//Isotope product loaded via AJax, break Select function;
var updateSelect = function () {
    jQuery(window).trigger("upDateEvent");
};


var Isotope = Isotope || undefined;
if (Isotope !== undefined) {
    /**
     * Display a "loading data" message
     * @param string
     * @param boolean
     */
    Isotope.displayBox = function (message, btnClose) {

        var box = document.getElementById('iso_ajaxBox');
        var overlay = document.getElementById('iso_ajaxOverlay');

        if (!overlay) {
            overlay = document.createElement('div');
            overlay.setAttribute('id', 'iso_ajaxOverlay');
            document.body.appendChild(overlay);
        }

        if (!box) {
            box = document.createElement('div');
            box.setAttribute('id', 'iso_ajaxBox');
            document.body.appendChild(box);
        }

        if (btnClose) {
            overlay.addEventListener('click', Isotope.hideBox, false);
            box.addEventListener('click', Isotope.hideBox, false);
            if ((!box.className.search(/btnClose/)) != -1) {
                box.className = box.className + ' btnClose';
            }
        }

        var scroll = window.getScroll().y;

        overlay.style.display = 'block';
        if (btnClose) {
            box.innerHTML = '<div class="cartAdd">' + message + '</div>';
        } else {
            box.innerHTML = message;
        }

    };

}

var IsotopeProducts = function () {
    "use strict";
    var loadMessage = "Loading product data …";

    function initProduct(config) {
        var form = document.getElementById(config.formId);
        if (form) {
            registerEvents(form, config);
        }
    }

    function registerEvents(form, config) {
        var i, el, xhr;
        xhr = new Request.HTML({
            url: form.action,
            link: "cancel",
            evalScripts: false,
            onRequest: function () { Isotope.displayBox.pass(loadMessage); },
            onSuccess: function (responseTree, responseElements, txt, responseJavaScript) {
                Isotope.hideBox();
                var div = document.createElement("div");
                div.innerHTML = txt;
                var newForm = div.firstChild;
                var errors = div.getElementsByTagName("p");
                for (var i = 0; i < errors.length; i++) {
                    if (errors[i].className.search(/(^| )error( |$)/) != -1) {
                        errors[i].parentNode.removeChild(errors[i]);
                    }
                }
                form.parentNode.replaceChild(newForm, form);
                registerEvents(newForm, config);
                Browser.exec(responseJavaScript);
                updateSelect();
            },
            onFailure: Isotope.hideBox
        });
        if (config.attributes) {
            for (i = 0; i < config.attributes.length; i++) {
                el = document.getElementById("ctrl_" + config.attributes[i] + "_" + config.formId);
                if (el) {
                    el.addEventListener("change", function () {
                        xhr.send(form.toQueryString());
                    }, false);
                }
            }
        }
    }
    return {
        attach: function (products) {
            var i;
            if (Object.prototype.toString.call(products) === "[object Array]" && products.length > 0) {
                for (i = 0; i < products.length; i++) {
                    initProduct(products[i]);
                }
            }

        },
        setLoadMessage: function (message) {
            loadMessage = message || "Loading product data …";
        }
    };
}();
